import { z } from "zod";

export const transacaoTipoSchema = z.enum(["credito", "debito"]);

export const transacaoResponseSchema = z.object({
  id: z.number(),
  tipo: transacaoTipoSchema,
  valor: z.number(),
  descricao: z.string(),
  createdAt: z.string(),
});

export const carteiraSaldoResponseSchema = z.object({
  saldo: z.number(),
  updatedAt: z.string(),
});

export const carteiraExtratoResponseSchema = z.object({
  transacoes: z.array(transacaoResponseSchema),
  total: z.number(),
  page: z.number(),
  limit: z.number(),
});

export type TransacaoTipo = z.infer<typeof transacaoTipoSchema>;
export type TransacaoResponseDto = z.infer<typeof transacaoResponseSchema>;
export type CarteiraSaldoResponseDto = z.infer<typeof carteiraSaldoResponseSchema>;
export type CarteiraExtratoResponseDto = z.infer<typeof carteiraExtratoResponseSchema>;
